import { render } from "./PoliceStation.vue?vue&type=template&id=f5637698&scoped=true"
import script from "./PoliceStation.vue?vue&type=script&lang=js"
export * from "./PoliceStation.vue?vue&type=script&lang=js"

import "./PoliceStation.vue?vue&type=style&index=0&id=f5637698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5637698"]])

export default __exports__